module.exports = __webpack_public_path__ + "img/RASectionBG.9f4ad168.jpeg";